export default __webpack_public_path__ + "static/media/switch_batch.7f081989.svg";